import { getApiClient } from '@treneo/infrastructure/api';

import { UsersApi } from './users.api';

export * from './users.api';

export const usersApi = new UsersApi(getApiClient());
